<template>
  <div class="row">

    <div class=" col-sm-12">
      <text-group label="会社名" v-model="company.name" :val="company.name">
        <div slot="line"/>
      </text-group>
      <text-group label="">
        <template slot="text">
          <button class="btn btn-primary" @click="searchCompany">企業データ検索</button>
          <corporate-row :corporates="corporates" @activate="activate"></corporate-row>
        </template>
      </text-group>

      <text-group label="法人番号" v-model="company.corporate_number" :val="company.corporate_number"/>
      <text-group label="会社名_かな" v-model="company.name_kana" :val="company.name_kana"/>
      <text-group label="上場区分">
        <template slot="text">
          <select class="form-control" v-model="company.stock_type">
            <option value="">未選択</option>
            <option value="未上場">未上場</option>
            <option value="東証一部">東証一部</option>
            <option value="東証二部">東証二部</option>
            <option value="JASDAQ">JASDAQ</option>
            <option value="東証マザーズ">東証マザーズ</option>
          </select>
        </template>
      </text-group>
      <text-group label="会社URL" v-model="company.corporate_url" :val="company.corporate_url"></text-group>
      <text-group label="">
        <template slot="text">
          <a :href="`https://www.google.com/search?q=${company.name}`" target="_blank">Google検索</a>
        </template>
      </text-group>

      <text-group label="登記日" v-model="company.registration_at" :val="company.registration_at"></text-group>
      <text-group label="郵便番号" v-model="company.zip" :val="company.zip"></text-group>
      <text-group label="住所" v-model="company.address" :val="company.address"></text-group>
      <text-group label="資本金" v-model="company.capital" :val="company.capital"></text-group>
      <text-group label="代表取締役" v-model="company.ceo" :val="company.ceo"></text-group>
      <text-group label="従業員数" v-model="company.employer_count" :val="company.employer_count"></text-group>
      <text-group label="企業紹介_タイトル" v-model="company.strength_title" :val="company.strength_title"></text-group>
      <text-group label="企業紹介_詳細" >
        <template slot="text">
          <textarea v-model="company.strength_detail" rows="5" class="form-control"></textarea>
        </template>

      </text-group>

    </div>
    <button class="btn btn-success btn-block" @click="updateCompany">更新</button>
  </div>
</template>

<script>
  import Api from '../../service/Api.vue'
  import CorporateApi from '../../service/CorporateApi'
  import CompanySearch from '../../components/company/Search.vue'
  import CorporateRow from '../../components/company/CorporateRow.vue'

  export default {
    props: [
      'id'
    ],
    data () {
      return {
        company: {
          company_id: '',
          corporate_number: '',
          name: '',
          name_kana: '',
          stock_type: '',
          corporate_url: '',
          registration_at: '',
          zip: '',
          address: '',
          capital: '',
          ceo: '',
          employer_count: '',
          strength_title: '',
          strength_detail: ''
        },
        corporates: []
      }
    },
    created () {
      if (this.id) {
        this.$store.commit('modalShow', true)
        Api.company.get(this.id)
          .then((response) => {
            const company = response.data.company || {}
            window.console.log(company)
            this.company = {
              corporate_number: company.corporate_number || '',
              name: company.name || '',
              name_kana: company.name_kana || '',
              stock_type: company.stock_type || '',
              corporate_url: company.corporate_url || '',
              registration_at: company.registration_at || '',
              zip: company.zip || '',
              address: company.address || '',
              capital: company.capital || '',
              ceo: company.ceo || '',
              employer_count: company.employer_count || '',
              strength_title: company.strength_title || '',
              strength_detail: company.strength_detail || ''
            }
            this.$store.commit('modalShow', false)
          })
          .catch(() => {
            location.href = '/'
          })
      }
    },
    methods: {
      searchCompany () {
        this.$store.commit('modalShow', true)
        CorporateApi.corporate.list({
          name: this.company.name
        }).then((response) => {
          this.corporates = response.data.corporates || []
          this.$store.commit('modalShow', false)
        }).catch(() => {
          this.$store.commit('modalShow', false)
        })
      },
      activate (corporate) {
        this.company.name = corporate.name
        this.company.name_kana = corporate.kana_name
        this.company.corporate_number = corporate.corporate_number
        this.company.corporate_url = corporate.corporate_url
        this.company.stock_type = corporate.stock_type
        // this.company.registration_at = corporate.created_at
        this.company.zip = corporate.zip
        this.company.address = corporate.prefecture_name + corporate.city_name + corporate.street_address
      },
      async checkNumber (corporateNumber) {
        try {
          const response = await Api.company.corporateNumber(corporateNumber)
          if (!this.id) {
            return false
          }
          const company = response.data.company || {}
          return Number(this.id) === company.company_id
        } catch (e) {
          window.console.log(e)
        }
        return true
      },
      async updateCompany () {
        this.$store.commit('modalShow', true)

        const company = this.company
        if (company.corporate_number) {
          if (!await this.checkNumber(company.corporate_number)) {
            this.$store.commit('modalShow', false)

            return
          }
        }
        if (this.id) {
          Api.company.put(this.id, company)
            .then((response) => {
              this.$store.commit('modalShow', false)
              window.alert('保存しました')
            })
            .catch((response) => {
              this.$store.commit('modalShow', false)
              window.console.log('NG')
            })
        } else {
          Api.company.post(company)
            .then((response) => {
              this.$store.commit('modalShow', false)
              window.alert('保存しました')
            })
            .catch((response) => {
              this.$store.commit('modalShow', false)
              window.console.log('NG')
            })
        }
      }
    },
    components: {
      CompanySearch,
      CorporateRow
    }
  }
</script>



// WEBPACK FOOTER //
// Form.vue?2321c412